import React from "react";
import styled from "styled-components";
import { fonts, colors, mediaQueries } from "../shared/config";
import SnakerMan from "../images/snakerman.png";

const Container = styled.div`
  background: white;
  /* min-height: 80vh; */
  color: black;
  padding-left: 5vw;
  display: grid;
  grid-template-columns: 2fr 1fr;
  padding-bottom: 5vw;
  padding-top: 5vw;
  align-content: center;
  ${mediaQueries.mobile} {
    display: block;
    /* grid-template-columns: 1fr; */
    justify-content: center;
    padding: 10px;
  }
  ${mediaQueries.tablet} {
    display: block;
    /* grid-template-columns: 1fr; */
    justify-content: center;
    padding: 10px;
  }
  column-gap: 84px;
`;



const Text = styled.div`
  font-family: Cardo;
  font-style: normal;
  font-weight: normal;
  margin-top: 30px;
  font-size: 18px;

  ${mediaQueries.mobile} {
    padding: 0 20px;
    margin-top: 5px;
  }
  ${mediaQueries.tablet} {
    padding: 0 20px;
    margin-top: 5px;
  }
`;

const ImageContainer = styled.div`
  padding: auto;
  width: 100%;
  align-items: center;
  align-content: center;
  /* display: flex;
  flex-direction: column; */
  /* ali */
  ${mediaQueries.tablet} {
    width: 100%;
  }
  ${mediaQueries.mobile} {
    width: 100%;
  }
`;

const Image = styled.img`
  width: 70%;
  margin-top: 42px;
  align-self: center;
  align-content: center;
  
  ${mediaQueries.tablet} {
    /* width: 100% !important; */
    align-items: center !important;
    margin-top: 0;
    margin-left: 20px;
    /* margin-right: 20px; */
    width: calc(100% - 40px);
  }
  
  ${mediaQueries.mobile} {
    /* width: 95% !important; */
    align-items: center !important;
    margin-top: 0;
    margin-left: 20px;
    /* margin-right: 20px; */
    width: calc(100% - 40px);
    
  }
 
`;

const Credits = styled.div`
  font-family: ${fonts.credits};
  font-weight: 400;
  padding-left: 10px;
  font-size: 12px;
  padding-right: 10px;
  ${mediaQueries.mobile} {
    text-align: right;
  }
  ${mediaQueries.tablet} {
    text-align: right;
  }
`;

const Title = styled.div`
  font-size: 96px;
  line-height: 90%;
  font-family: Staatliches;
  margin-top: 93px;
  color: #A32929;

  ${mediaQueries.tablet} {
    margin-top: 40px;
    margin-left: 20px;
    font-size: 80px;
  }
  ${mediaQueries.mobile} {
    margin-top: 40px;
    margin-left: 20px;
    font-size: 36px;
  }
`;

const Subheading = styled.div`
  font-size: 48px;
  line-height: 90%;
  font-family: Staatliches;
  
  ${mediaQueries.tablet} {
    /* margin-top: 40px; */
    margin-left: 20px;
    font-size: 40px;
  }
  ${mediaQueries.mobile} {
    /* margin-top: 40px; */
    margin-left: 20px;
    font-size: 24px;
    padding-bottom: 20px ;
  }
`;

export default function NewCloseQuarters(props) {
  return(

     
      <Container>
        <div>
        {props.data.map(block=>{
          if(block.type==="header"){
              return(<Title>{block.content}</Title>);
          }
          if(block.type==="subheader"){
            return(<Subheading>{block.content}</Subheading>);
        }
          if(block.type === "paragraph"){
            return(
              <Text>{block.content}</Text>
            )
          }

          })} 

        </div>
        <ImageContainer>
          {props.data.map(block=>{
            if(block.type === "image"){
              return(
                <>
                  <Image src={block.image_link} alt="snakerman"></Image>
                  <Credits> {block.image_credits} </Credits>
                </>
              )
            }

            })} 

        </ImageContainer>
        
       

      </Container>

  )};